import React from "react";

const XIcon = ({ className = "w-7 h-7", isActive = false, ...props }) => {
  const gradientId = `primaryGradientX-${React.useId()}`;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${className} flex-shrink-0`}
      {...props}
    >
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FFE48A" />
          <stop offset="50%" stopColor="var(--color-primary)" />
          <stop offset="100%" stopColor="#A87A1F" />
        </linearGradient>
      </defs>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={isActive ? "2" : "1.5"}
        stroke={`url(#${gradientId})`}
        d="M6 18 18 6M6 6l12 12"
      />
    </svg>
  );
};

export default XIcon;
